import React from "react";
import { useNavigate } from "react-router-dom";
import { z } from "zod";

import { ButtonStandard, FormInputText, ModalBase, PYForm, SubmitButton, Text } from "@performyard/py-components";

import { NAME_MAX_LENGTH } from "../../../Workflows/TemplateEditor/todoForm";

const CreateTemplateSchema = z.object({
	name: z
		.string()
		.trim()
		.min(1, "This is a required field")
		.max(NAME_MAX_LENGTH, `Name must be ${NAME_MAX_LENGTH} characters or less`),
});

/**
 * Names a new workflow template, then hands off to the template editor. Nothing is
 * persisted here — the server requires a template to have at least one to-do, so the
 * template is created by the editor's first "Save Template".
 */
const CreateWorkflowTemplateModal = ({ onClose }: { onClose: () => void }) => {
	const navigate = useNavigate();

	return (
		<ModalBase isOpen onClose={onClose}>
			<div className="flex w-96 max-w-[calc(100vw-48px)] flex-col gap-4 px-6 pb-6">
				<div className="text-center">
					<Text size="sub-heading" weight="semi-bold">
						Create New Template
					</Text>
				</div>

				<PYForm
					id="create-workflow-template-form"
					schema={CreateTemplateSchema}
					defaultValues={{ name: "" }}
					onSubmit={({ value }) => {
						navigate(`/edit-workflow/?name=${encodeURIComponent(value.name.trim())}`);
					}}
				>
					<FormInputText
						id="name"
						label="Template Name"
						placeholder="Your text here"
						data-testid="create-template-name-input"
					/>
					<div className="mt-6 flex justify-center gap-2">
						<ButtonStandard
							type="button"
							variant="outline"
							color="neutral"
							size="large"
							dangerouslySetClassName="w-fit"
							onClick={onClose}
						>
							Cancel
						</ButtonStandard>
						<SubmitButton size="large" dangerouslySetClassName="w-fit">
							Create New Template
						</SubmitButton>
					</div>
				</PYForm>
			</div>
		</ModalBase>
	);
};

export default CreateWorkflowTemplateModal;
